

<template>

  <v-container
    fill-height
    fluid
  >
    <v-row justify="center">

      <material-card

        :title="$t('login.title')"
        :text="$t('login.text')"

      >
        <v-form @submit.prevent="loginUser">
          <v-container >
            <v-row>


              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="username"
                  :label="$t('login.username')"


                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="password"
                  :label="$t('login.password')"

                  type="password"

                />
              </v-col>

              <v-col
                cols="12"
                class="text-right"
              >
                <v-btn :loading="loading" type="submit" color="success">
                  {{$t("login.login")}}
                </v-btn>
              </v-col>

            </v-row>
            <v-row>
              <v-col
                cols="12"
               >
                {{$t("login.forgotPassword")}}  <v-btn text small to="/forgotPassword">{{$t("login.forgotPasswordClickHere")}}</v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-btn text small href="https://www.almesolutions.no/programvare/" target="_blank">{{$t("login.aboutObara")}}  </v-btn>

              </v-col>
            </v-row>

            <v-alert v-if='loginError' type="error">
              {{$t('login.loginFailed')}}
            </v-alert>
          </v-container>
        </v-form>
      </material-card>

    </v-row>
  </v-container>
</template>


<script>
    import {AUTH_REQUEST} from '../store/actions/auth'
    import VueAnalytics from "vue-analytics";

    export default {
        data () {
            return {
                username: '',
                password: '',
                loading:false,
                loginError:false
            }
        },
        methods: {


            loginUser () {
                this.loading = true
                 const { username, password } = this
                this.$store.dispatch(AUTH_REQUEST, { username, password }).then(() => {
                  //this.$ga.set("dimension1", this.$store.state.curCustomer)
                  this.$router.push('/')
                })
                    .catch(()=> {
                        this.loading=false
                        this.loginError = true
                })
            }





        },
    }
</script>
